<template>
  <div class="fixed inset-0 z-2000 h-dvh w-dvh">
    <main class="bg-white text-black w-dvw h-dvh">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'

onMounted(() => {
  document.body.style.overflow = 'hidden'
})
onBeforeUnmount(() => {
  document.body.style.overflow = ''
})
</script>
